import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

import { ConectorProvider } from "../../providers/conector/conector";



@Component({
  selector: 'page-notificacion-detalle',
  templateUrl: 'notificacion-detalle.html',
})



export class NotificacionDetallePage {
  data : any = {};

  notificacion :any = {
    id:null,
    fechaenvio:null,
    texto:"Texto"
  }; 
  
  constructor(public navCtrl: NavController, public navParams: NavParams, public conector:ConectorProvider) {
    this.data = {
      "background"      : "assets/images/background/39.jpg", 
   };

    console.log("param", this.navParams )

    this.notificacion = this.navParams.data["notif"]

    let TextLOG = "Acceso a notificación  id:" + this.notificacion.id +" - "+this.notificacion.texto

    this.conector.registraractividad( TextLOG).subscribe(data=>{
      console.log("registramos Actividad",TextLOG )
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NotificacionDetallePage');
  }

  volver(){
    console.log("volvemps ")
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/notificacion-detalle/notificacion-detalle.ts